import { config } from '@/config';

export const setLocaleCookie = (locale = config.defaultLocale) => {
    const daysUntilExpiry = 30;
    const daysUntilExpiryMilliseconds = daysUntilExpiry * 24 * 60 * 60 * 1000;
    const expiryDate = new Date(Date.now() + daysUntilExpiryMilliseconds);
    const expiryString = '; expires=' + expiryDate.toUTCString();
    document.cookie = `${config.localeCookieName}=${locale}${expiryString};path=/`;
};
